enum FactoryInvoicingModel {
  PERIODICAL = "periodical",
  BY_SHIPMENTS_TO_HQ = "by shipments to the HQ",
  BY_SHIPMENTS_TO_HQ_AND_PERIODICAL = "by shipments to the HQ + periodical by direct shipments",
}

export default FactoryInvoicingModel;
